import { render, staticRenderFns } from "./COWorkerSessionsList.vue?vue&type=template&id=5bda6bf2"
import script from "./COWorkerSessionsList.vue?vue&type=script&lang=js"
export * from "./COWorkerSessionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/ffa2b6072150c7f8/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bda6bf2')) {
      api.createRecord('5bda6bf2', component.options)
    } else {
      api.reload('5bda6bf2', component.options)
    }
    module.hot.accept("./COWorkerSessionsList.vue?vue&type=template&id=5bda6bf2", function () {
      api.rerender('5bda6bf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/CrossOrg/COWorkerSessionsList.vue"
export default component.exports